import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../Constant";
import ComplaintsForm from "./ComplaintsForm";

const ComplaintsAdd = () => {
    return (
        <Fragment>
            <ComplaintsForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default ComplaintsAdd;